const trim = (value: string | undefined) => value?.trim().replace(/\/+$/, '') || ''

/** AloUbot: nơi đăng nhập (OIDC) và cấp token MeetUbot. MeetUbot dùng chung tài khoản với AloUbot. */
const aloubotUrl = trim(import.meta.env.VITE_ALOUBOT_URL) || 'http://localhost:3001'

export const config = {
  name: 'MeetUbot',
  aloubotUrl,
  issuer: `${aloubotUrl}/oidc`,
  aloubotApi: `${aloubotUrl}/api/v1`,
  clientId: 'meetubot',
  /** Máy chủ MeetUbot: cùng origin với app (nginx / Vite chuyển /api/v1 và /socket.io). */
  meetApi: '/api/v1',
  storageKeys: { auth: 'meetubot.auth', login: 'meetubot.login', org: 'meetubot.org', devices: 'meetubot.devices', name: 'meetubot.name' },
}
